import { useHotkeys } from 'react-hotkeys-hook'

import { useLayoutEditorContext } from 'features/views/LayoutEditor/useLayoutEditorContext'

export function useLayoutEditorCanvasKeyboardShortcuts() {
    const { commands, selection } = useLayoutEditorContext()

    useHotkeys(
        'ctrl+z, meta+z',
        commands.undo,
        {
            preventDefault: true,
            enabled: disableIfPopupIsOpen,
        },
        [commands.undo]
    )
    useHotkeys(
        'ctrl+shift+z, meta+shift+z',
        commands.redo,
        {
            preventDefault: true,
            enabled: disableIfPopupIsOpen,
        },
        [commands.redo]
    )

    useHotkeys(
        'delete, backspace',
        () => {
            commands.removeSelectedWidget()
        },
        {
            enabled: () => {
                if (selection?.type !== 'widget') return false

                return disableIfPopupIsOpen()
            },
        },
        [commands.removeSelectedWidget]
    )

    useHotkeys(
        'ctrl+d, meta+d',
        () => {
            commands.duplicateSelectedWidget()
        },
        {
            enabled: () => {
                if (selection?.type !== 'widget') return false

                return disableIfPopupIsOpen()
            },
        },
        [commands.duplicateSelectedWidget]
    )
}

function disableIfPopupIsOpen() {
    // If there is any type of pop-up open, just return false.
    if (!!document.querySelector('.ag-custom-component-popup')) {
        return false
    }

    return true
}
